interface BuddyProps {
  size?: number;
}

/** Buddy mascot — inline SVG character. 1:1 port from polished_prototype/app.jsx. */
export function Buddy({ size = 110 }: BuddyProps) {
  return (
    <svg viewBox="0 0 110 110" width={size} height={size} aria-hidden="true">
      <ellipse cx="55" cy="62" rx="36" ry="34" fill="var(--accent-soft)" stroke="var(--accent)" strokeWidth="2" />
      <ellipse cx="55" cy="68" rx="22" ry="20" fill="var(--surface)" stroke="var(--accent)" strokeWidth="1" opacity="0.7" />
      <circle cx="44" cy="52" r="4" fill="var(--ink)" />
      <circle cx="66" cy="52" r="4" fill="var(--ink)" />
      <circle cx="45" cy="51" r="1.3" fill="white" />
      <circle cx="67" cy="51" r="1.3" fill="white" />
      <circle cx="38" cy="60" r="3" fill="var(--accent)" opacity="0.4" />
      <circle cx="72" cy="60" r="3" fill="var(--accent)" opacity="0.4" />
      <path d="M48 62 Q55 68 62 62" stroke="var(--ink)" strokeWidth="2" fill="none" strokeLinecap="round" />
      <line x1="55" y1="28" x2="55" y2="18" stroke="var(--ink)" strokeWidth="2" />
      <circle cx="55" cy="15" r="4" fill="var(--amber)" stroke="var(--ink)" strokeWidth="1.5" />
      <path d="M84 30 L86 34 L90 36 L86 38 L84 42 L82 38 L78 36 L82 34 Z" fill="var(--teal)" opacity="0.7" />
    </svg>
  );
}
